module.exports = (__parcel__import__("amSxg")).then(() => parcelRequire('fyWP3'));